export enum ProcessEngineerEventName {
  UserEntersProcessEngineerDashboard = 'userEntersProcessEngineerDashboard'
}

export type ProcessEngineerEvent = {
  name: ProcessEngineerEventName.UserEntersProcessEngineerDashboard
}
